module.exports = __webpack_public_path__ + "static/media/physician-bill-pay-light.ec7a9d34.png";